import React, { forwardRef, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Tokens } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';

type Props = {
	children: ReactNode;
	label: string;
	addTab?: React.ReactNode;
};

const TabList = forwardRef(({ children, label, addTab }: Props, ref: React.Ref<HTMLDivElement>) => (
	<ResponsiveNav aria-label={label}>
		<Wrapper ref={ref}>{children}</Wrapper>

		{addTab}
	</ResponsiveNav>
));

export default TabList;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	gap: token('space.150'),
	overflow: 'auto',
	marginTop: token('space.0'),
	marginBottom: token('space.0'),
	marginLeft: token('space.negative.300'),
	marginRight: token('space.negative.150'),
	paddingTop: token('space.0'),
	paddingBottom: token('space.0'),
	paddingLeft: token('space.300'),
	paddingRight: token('space.200'),
	maskImage: `linear-gradient( to right, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) ${token('space.150')}, rgba(0, 0, 0, 1) calc(100% - ${token('space.150')}), rgba(0, 0, 0, 0) 100% )`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ResponsiveNav = styled.nav({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	gap: token('space.150'),

	position: 'relative',
	minWidth: token('space.0'),
	paddingLeft: token('space.300'),
	paddingRight: token('space.300'),
	// underline separating tabs from page content
	'&::before': {
		content: "''",
		position: 'absolute',
		bottom: token('space.0'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		background: Tokens.COLOR_BORDER,
		height: token('space.025'),
		left: token('space.0'),
		right: token('space.0'),
	},
});
